export enum ApelacionEstados {
	creada = 1,
	rechazada = 2,
	acogimiento_parcial = 3,
	acogimiento_total = 4,
}
